<template>
    <div class="placeAdd">
        <Head-view :showStyle="2"></Head-view>
        <div class="main">
            <div class="breadcrumb" @click="backClose()">
                点位管理 &nbsp;/&nbsp;
                <span style="color: rgba(132, 133, 135, 1)">{{
                    editTitle
                }}</span>
            </div>
            <div class="breadcrumbChilder">{{ editTitle }}</div>
            <div class="showTba">
                <div class="addBox">
                    <div class="instMsg">点位信息</div>
                    <div class="commRowstyle logo">
                        <div class="inpTitle logoSplick">图片</div>
                        <div
                            class="addHeadImg"
                            :class="[!imgHead ? 'borderClass' : '']"
                        >
                            <input
                                type="file"
                                name="file"
                                ref="headImgRef"
                                accept="image/*,.jpg,.png,.git,.webp,.svg,"
                                @change="uploadHeadImg()"
                                v-if="!imgHead"
                            />
                            <img :src="imgHead" v-if="imgHead" alt="" />
                            <div
                                class="delHeadImg"
                                v-if="imgHead"
                                @click="delHeadImg()"
                            >
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>点位名称</div>
                        <div class="inpFrom">
                            <el-input
                                v-model="instMsg.name"
                                placeholder="请输入"
                                @blur="trimBoth('name', instMsg.name)"
                            ></el-input>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>定位地点</div>
                        <div class="inpFrom posiInp">
                            <div class="posiFont">经度：</div>
                            <div class="posiImport">
                                <el-input
                                    v-model="instMsg.longitude"
                                    placeholder="请输入"
                                ></el-input>
                            </div>
                            <div class="posiFont">纬度：</div>
                            <div class="posiImport">
                                <el-input
                                    v-model="instMsg.latitude"
                                    placeholder="请输入"
                                ></el-input>
                            </div>
                            <div class="getPosiBtn">
                                <el-popover
                                    placement="right"
                                    width="1054"
                                    trigger="manual"
                                    popper-class='custom-poper'
                                    v-model="visible"
                                >
                                    <div class="mapBox">
                                        <baidu-map
                                            class="map"
                                            :center="centerPosi"
                                            :zoom="15"
                                            :scroll-wheel-zoom="true"
                                            @click="paintPolyline"
                                        >
                                            <bm-marker
                                                v-if="Object.keys(mapPostObj).length > 0"
                                                :position="mapPostObj"
                                                :dragging="false"
                                                :icon="{
                                                    url: 'https://ylsqfile-dev.zhiyanglao.cn/1yppDvxYnM70vC6sopoERDM72XY3VzPw/image',
                                                    size: {
                                                        width: 33,
                                                        height: 80,
                                                    },
                                                }"
                                            ></bm-marker>
                                        </baidu-map>

                                        <div class="configBtnMap" @click="confirmPosi()">确定</div>
                                        <div class="configBtnMap closeBtnMap" @click="closePosi()">取消</div>
                                    </div>
                                    <el-button slot="reference" type="primary" @click="getPosiBtn()">
                                        拾取坐标
                                    </el-button>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                    <div class="requirementBody marginTop_30">
                        <div class="requirementTop">
                            <div class="requirementTitle">巡检要求</div>
                            <div
                                class="requirementAddBtn"
                                @click="addPlaceRequBtn()"
                            >
                                添加巡检要求
                            </div>
                        </div>
                        <div class="requirementTab">
                            <el-table
                                :data="tableData"
                                stripe
                                style="width: 100%"
                                height="350"
                                :header-cell-style="{
                                    backgroundColor: 'rgba(246, 245, 245, 1)',
                                    height: '56px',
                                }"
                                v-loading="loading"
                            >
                                <el-table-column
                                    prop="title"
                                    label="标题"
                                    width="196"
                                >
                                </el-table-column>
                                <el-table-column label="描述" width="528">
                                    <template slot-scope="scope">
                                        <div
                                            v-html="scope.row.desc"
                                            class="descFont"
                                        ></div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="200" label="反馈">
                                    <template slot-scope="scope">
                                        <div class="status">
                                            状态<span
                                                v-if="scope.row.checkedFont"
                                                >/文字</span
                                            ><span v-if="scope.row.checkedImg"
                                                >/图片</span
                                            >
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    fixed="right"
                                    label="操作"
                                    width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            size="mini"
                                            class="colorGreen"
                                            @click="
                                                handleEdit(
                                                    scope.$index,
                                                    scope.row
                                                )
                                            "
                                            >编辑</el-button
                                        >
                                        <el-button
                                            size="mini"
                                            type="danger"
                                            @click="
                                                handleDelete(
                                                    scope.$index,
                                                    scope.row
                                                )
                                            "
                                            >删除</el-button
                                        >
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            <div class="btn">
                <div class="commBtn closeBtn" @click="backClose()">取消</div>
                <div class="commBtn successBtn" @click="submitData()">保存</div>
            </div>
        </div>

        <el-dialog
            title="巡检要求"
            :visible.sync="dialogVisible"
            width="960px"
            height="503px"
        >
            <div class="dialogFrom">
                <div class="fromBox">
                    <div class="fromBoxFont"><span>*</span>标题</div>
                    <div class="fromBoxInp">
                        <el-input
                            v-model="requirementObj.title"
                            placeholder="请输入"
                            @blur="
                                trimBoth('requireTitle', requirementObj.title)
                            "
                        ></el-input>
                    </div>
                </div>
                <div class="fromBox marginTop_30">
                    <div class="fromBoxFont"><span>*</span>描述</div>
                    <div class="fromBoxInp textarea">
                        <el-input
                            v-model="requirementObj.desc"
                            type="textarea"
                            resize="none"
                            :autosize="{ minRows: 4, maxRows: 4 }"
                            placeholder="请输入内容"
                        ></el-input>
                    </div>
                </div>

                <div class="fromBox marginTop_30">
                    <div class="fromBoxFont">反馈</div>
                    <div class="fromBoxInp">
                        <p class="fromBoxInp_p">
                            <el-checkbox v-model="requirementObj.checkedFont"
                                >文字</el-checkbox
                            >
                        </p>
                        <p>
                            <el-checkbox v-model="requirementObj.checkedImg"
                                >图片</el-checkbox
                            >
                        </p>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button
                    class="successBtn"
                    type="primary"
                    @click="addPlaceRequ()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getCookie } from "../../../untils/tools";

import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import { BmlMarkerClusterer } from "vue-baidu-map";
export default {
    name: "placeAdd",
    data() {
        return {
            imgHead: "",
            fileImg: "",
            insId: "",
            instMsg: {
                name: "",
                longitude: "", //经度
                latitude: "", //纬度
            },
            dialogVisible: false,
            loading: false,

            requirementObj: {
                title: "",
                desc: "",
                checkedFont: false,
                checkedImg: false,
            },

            tableData: [],

            centerPosi: { lng: 116.404, lat: 39.915 },
            mapPostObj: {},
            visible: false,

            editTitle: "新增巡检点位",
            editFlag: false, //是否为编辑
            editNumber: -1,
        };
    },

    components: {
        HeadView,
        BaiduMap,
        BmlMarkerClusterer,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"))
        if (this.$route.query.id) {
            this.editTitle = "编辑巡检点位";
            this.editFlag = true;
            this.placeId = this.$route.query.id;
            this.placeEditInfo(this.$route.query.id);
        }
    },

    methods: {
        addPlaceRequ() {
            if (!this.requirementObj.title || !this.requirementObj.desc) {
                return this.$message({
                    type: "warning",
                    message: "带*标志的均不能为空",
                });
            }
            this.dialogVisible = false;

            if (this.editNumber >= 0) {
                this.tableData[this.editNumber] = this.requirementObj;
                this.$message({
                    type: "success",
                    message: "修改成功",
                });
            } else {
                this.tableData.push(this.requirementObj);
                this.$message({
                    type: "success",
                    message: "添加成功",
                });
            }
            this.editNumber = -1;

            this.requirementObj = {
                title: "",
                desc: "",
                checkedFont: false,
                checkedImg: false,
            };
        },

        addPlaceRequBtn() {
            this.dialogVisible = true;
            this.editNumber = -1;
            this.requirementObj = {
                title: "",
                desc: "",
                checkedFont: false,
                checkedImg: false,
            };
        },

        placeEditInfo(id) {
            let data = {
                token: this.getCookie(),
                placeId: id,
            };
            this.request
                .post(this.baseUrl + "place/getPlaceDetail", data)
                .then((res) => {
                    if (res.code == 0 && res.data.placeId >= 0) {
                        this.instMsg = res.data;
                        this.imgHead = res.data.picture;
                        let requirementArr = JSON.parse(res.data.requirement);
                        requirementArr.forEach((item) => {
                            this.tableData.push({
                                title: item.name,
                                desc: item.description,
                                checkedFont: item.need_text,
                                checkedImg: item.need_picture,
                            });
                        });
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message({
                        type: "warning",
                        message: "获取点位详情失败",
                    });
                });
        },

        trimBoth(type, val) {
            let trimVal = val.trim();

            switch (type) {
                case "name":
                    this.instMsg.name = trimVal;
                    break;
                case "requireTitle":
                    this.requirementObj.title = trimVal;
                    break;
                // case "address":
                //     var regexp = /[^\d，,]]*/g;
                //     this.instMsg.phone = val.replace(regexp, "");
                //     break;
            }
        },

        uploadHeadImg() {
            //头像
            let _this = this;
            let file = this.$refs.headImgRef.files[0];
            this.fileImg = this.$refs.headImgRef.files[0]
            let imgData = new FileReader();
            imgData.readAsDataURL(file);
            imgData.onload = function (ev) {
                _this.imgHead = this.result;
            };
        },

        paintPolyline(e) {
            this.mapPostObj = e.point;
            return;
        },

        delHeadImg() {
            //清空头像
            this.imgHead = "";
            this.fileImg = "";
        },

        backClose() {
            this.$router.replace("/place");
        },

        handleDelete(index, row) {
            this.tableData.splice(index, 1);
        },

        handleEdit(index, row) {
            this.dialogVisible = true;
            this.editNumber = index;
            this.requirementObj = this.tableData[index];
        },

        submitData() {
            if (
                !this.instMsg.name ||
                !this.instMsg.longitude ||
                !this.instMsg.latitude
            ) {
                return this.$message({
                    type: "warning",
                    message: "带*标志的均不能为空",
                });
            }

            const loading = this.$loading({
                lock: true,
                text: "保存信息中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            if (this.imgHead && this.imgHead.indexOf("http") < 0) {
                let formData = new FormData()
                formData.append('file', this.fileImg)
                formData.append('token', this.getCookie())
                this.request
                    .post(this.commUrl + "uploadFile", formData)
                    .then((resUrl) => {
                        if (resUrl.code == 0) {
                            if (this.editFlag) {
                                this.upEditInfo(resUrl.data.url, loading);
                                return;
                            }
                            this.saveInformation(resUrl.data.url, loading);
                        } else {
                            loading.close();
                            this.$message({
                                type: "error",
                                message: resUrl.msg,
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        loading.close();
                        this.$message({
                            type: "error",
                            message: "图片上传失败",
                        });
                    });
            } else {
                if (this.editFlag) {
                    this.upEditInfo(this.imgHead, loading);
                    return;
                }
                this.saveInformation('', loading);
            }
        },

        saveInformation(url = "", loading) {
            let requirementArr = [];
            this.tableData.forEach((item, key) => {
                requirementArr.push({
                    index: key + 1,
                    name: item.title,
                    description: item.desc,
                    need_status: true,
                    need_text: item.checkedFont,
                    need_picture: item.checkedImg,
                });
            });
            let data = {
                token: getCookie(),
                insId: this.insId,
                name: this.instMsg.name,
                picture: url,
                longitude: this.instMsg.longitude,
                latitude: this.instMsg.latitude,
                requirement: JSON.stringify(requirementArr),
            };
            this.request
                .post(this.baseUrl + "place/addPlace", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "保存成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/place");
                            }, 1000);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        upEditInfo(url = "", loading) {
            let requirementArr = [];
            this.tableData.forEach((item, key) => {
                requirementArr.push({
                    index: key + 1,
                    name: item.title,
                    description: item.desc,
                    need_status: true,
                    need_text: item.checkedFont,
                    need_picture: item.checkedImg,
                });
            });
            let data = {
                token: this.getCookie(),
                placeId: this.placeId,
                name: this.instMsg.name,
                picture: url,
                longitude: this.instMsg.longitude,
                latitude: this.instMsg.latitude,
                requirement: JSON.stringify(requirementArr),
            };
            this.request
                .post(this.baseUrl + "place/updatePlace", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "修改成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/place");
                            }, 1000);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        getPosiBtn() {
            this.mapPostObj = {}
            this.visible = true
        },

        confirmPosi() {
            if (Object.keys(this.mapPostObj).length <= 0) {
                return this.$message({
                    type: 'warning',
                    message: "请先在地图中选择位置"
                })
            }
            this.instMsg.longitude = this.mapPostObj.lng
            this.instMsg.latitude = this.mapPostObj.lat
            this.visible = false
        },

        closePosi() {
            // this.mapPostObj = {}
            this.visible = false
        },

    },
};
</script>

<style lang="less" scoped>
.placeAdd {
    position: relative;
    height: 100vh;
    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            width: 180px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
            cursor: pointer;
        }
        .breadcrumbChilder {
            margin-top: 24px;
            height: 20px;
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }

        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            height: 692px;
            background: #fff;
        }
    }

    .addBox {
        padding: 24px 0 0 24px;
        .instMsg {
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            font-weight: 500;
        }

        .userNum {
            line-height: 40px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
        }

        .commRowstyle {
            display: flex;
            flex-direction: row;
            .inpTitle {
                width: 107px;
                color: rgba(84, 85, 86, 1);
                font-size: 14px;
                line-height: 40px;
                font-weight: 500;
                span {
                    color: red;
                }
            }
            .inpFrom {
                width: 265px;

                input {
                    width: 100%;
                }
            }

            .posiInp {
                display: flex;
                flex-direction: row;
                width: 416px;

                .posiFont {
                    width: 47px;
                    line-height: 40px;
                    font-size: 12px;
                    text-align: center;
                }

                .posiImport {
                    width: 102px;

                    /deep/ .el-input__inner {
                        width: 100%;
                    }
                }

                .getPosiBtn {
                    padding-left: 20px;

                    /deep/ .el-button {
                        background-color: #1989fa;
                    }
                }
            }

            .codeFont {
                line-height: 40px;
                font-size: 14px;
            }
        }

        .marginTop_30 {
            margin-top: 30px;
        }

        .marginLeft_40 {
            margin-left: 40px;
            text-align: left;
        }

        .logo {
            margin-top: 12px;
            .logoSplick {
                height: 60px;
                line-height: 60px;
            }
            .borderClass {
                border: 1px solid rgba(216, 220, 230, 1);
            }
            .addHeadImg {
                position: relative;
                width: 60px;
                height: 60px;
                background: url("../../../assets/addBtn.png") no-repeat center
                    center;
                overflow: hidden;
                input {
                    opacity: 0;
                    width: 100%;
                    height: 100%;
                }
                img {
                    width: 100%;
                }
                .delHeadImg {
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    color: #fff;
                    text-align: center;
                    line-height: 60px;
                }
            }
            .addHeadImg:hover .delHeadImg {
                display: block;
            }
        }
    }

    .foot {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 71px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;

        .btn {
            float: right;
            display: flex;
            flex-direction: row;
            padding-top: 15.5px;
            padding-right: 56px;
            .commBtn {
                width: 95px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .successBtn {
                color: rgba(255, 255, 255, 1);
                background: rgba(103, 194, 58, 1);
            }

            .closeBtn {
                margin-right: 24px;
                color: rgba(96, 98, 102, 1);
                font-size: 14px;
                font-weight: 500;
                border: 1px solid rgba(220, 223, 230, 1);
            }
        }
    }

    .requirementBody {
        width: 1134px;

        .requirementTop {
            width: 100%;
            height: 32px;
            clear: both;
        }

        .requirementTitle {
            float: left;
            height: 32px;
            line-height: 32px;
            color: rgba(84, 85, 86, 1);
            text-align: left;
        }

        .requirementAddBtn {
            float: right;
            width: 98px;
            height: 32px;
            opacity: 1;
            background-color: rgba(25, 137, 250, 1);
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 32px;
            border-radius: 4px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            vertical-align: top;
            cursor: pointer;
        }

        .requirementTab {
            padding-top: 21px;
            width: 100%;
            height: 350px;
            overflow-y: auto;

            .descFont {
                width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
            }
        }
    }

    .dialogFrom {
        padding-left: 71px;
        padding-bottom: 40px;

        .fromBox {
            display: flex;
            flex-direction: row;

            .fromBoxFont {
                width: 47px;
                height: 40px;
                line-height: 40px;
                color: rgba(128, 128, 128, 1);
                span {
                    color: rgba(255, 74, 74, 1);
                }
            }

            .fromBoxInp {
                width: 300px;

                /deep/ .el-input__inner {
                    width: 100%;
                }

                p {
                    /deep/ .is-checked .el-checkbox__inner {
                        background: rgba(25, 137, 250, 1);
                    }
                }

                .fromBoxInp_p {
                    margin-top: 10px;
                }
            }

            .textarea {
                width: 460px;
            }
        }

        .marginTop_30 {
            margin-top: 30px;
        }
    }
}

.mapBox {
    width: 100%;
    height: 600px;

    .map {
        width: 100%;
        height: 90%;
    }

    .configBtnMap {
        float: right;
        margin-top: 12px;
        width: 68px;
        height: 40px;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 4px;
        background: rgba(4, 134, 254, 1);
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .closeBtnMap {
        margin-right: 10px;
    }
}



/deep/ .el-dialog {
    display: flex;
    display: -ms-flex; /* 兼容IE */
    flex-direction: column;
    -ms-flex-direction: column; /* 兼容IE */
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.el-dialog .el-dialog__body {
    max-height: 100%;
    flex: 1;
    -ms-flex: 1 1 auto; /* 兼容IE */
    overflow-y: auto;
    overflow-x: hidden;
}

.el-dialog__wrapper {
    /*隐藏ie和edge中遮罩的滚动条*/
    overflow: hidden;
}

.dialog-footer {
    /deep/ .successBtn {
        background: rgba(64, 158, 255, 1);
        border-color: rgba(64, 158, 255, 1);
    }
}

/deep/ .el-input__inner {
    width: 256px;
}

.inpColorRed {
    /deep/ .el-input__inner {
        border: 1px solid red;
    }
}
</style>